import $ from 'jquery';
import 'magnific-popup';

import 'magnific-popup/dist/magnific-popup.css';

const initVideo = () => {
	$('[data-component="video"]').each(function () {
		$('.js-video-toggle').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
			iframe: {
				patterns: {
					youtu: {
						index: 'youtu.be',
						id: function (url) {
							const m = url.match(/^.+youtu\.be\/([^?]+)/);

							if (m !== null) {
								return m[1];
							}

							return null;
						},
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
					},
				},
			},
		});
	});
};

export default initVideo;